export const HEADERS = ['Программа', 'Ставка', 'Сумма', 'Срок', ''];
